import { motion } from "framer-motion";
import { Check, SlidersHorizontal } from "lucide-react";
import { Reveal, staggerContainer, staggerItem } from "@/components/site/Reveal";

const PLANS = [
  {
    name: "Básico",
    price: "149 €",
    unit: "/mes",
    features: ["Gestión de llamadas", "Atención al cliente", "Administración"],
    featured: false,
  },
  {
    name: "Profesional",
    price: "329 €",
    unit: "/mes",
    features: ["Todo lo del Básico", "Gestión de viajes", "Agenda y bandeja de entrada", "Eventos, informes y recados"],
    featured: true,
  },
  {
    name: "Empresa",
    price: "A medida",
    unit: "",
    features: ["Equipo dedicado", "Funciones a elegir", "Asistencia prioritaria"],
    featured: false,
  },
];

export default function PricingSection({ onCta }) {
  return (
    <section id="precios" className="scroll-mt-24 py-20 sm:py-24" data-testid="pricing-section">
      <div className="mx-auto max-w-6xl px-6">
        <Reveal className="text-center text-[13px] uppercase tracking-[0.12em] text-brand-gray">
          Precios
        </Reveal>
        <Reveal className="mx-auto mt-3 max-w-2xl text-center text-3xl sm:text-4xl font-medium tracking-tight text-brand-ink">
          Planes mensuales
        </Reveal>

        <motion.div
          variants={staggerContainer}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: "-40px" }}
          className="mx-auto mt-12 grid max-w-5xl items-start gap-5 md:grid-cols-3"
        >
          {PLANS.map((p) => (
            <motion.div
              key={p.name}
              variants={staggerItem}
              className={`relative rounded-[14px] bg-white p-8 ${
                p.featured
                  ? "border-2 border-brand-indigo shadow-[0_16px_40px_rgba(79,70,229,0.14)] md:-translate-y-2"
                  : "border border-brand-line"
              }`}
              data-testid={`plan-${p.name.toLowerCase()}`}
            >
              {p.featured && (
                <span className="absolute -top-3 left-1/2 -translate-x-1/2 rounded-full bg-brand-indigo px-4 py-1 text-[12px] font-medium text-white whitespace-nowrap">
                  Más popular
                </span>
              )}
              <p className="text-[14px] text-[#5F5E5A]">{p.name}</p>
              <p className="mt-1.5 text-4xl font-medium tracking-tight text-brand-ink">
                {p.price}
                {p.unit && <span className="text-[14px] font-normal text-brand-gray">{p.unit}</span>}
              </p>
              <ul className="mt-6 space-y-3">
                {p.features.map((f) => (
                  <li key={f} className="flex items-start gap-2.5 text-[14px] text-brand-ink">
                    <span className="mt-0.5 flex h-4 w-4 flex-shrink-0 items-center justify-center rounded-full bg-brand-mint">
                      <Check size={11} strokeWidth={3} className="text-white" />
                    </span>
                    {f}
                  </li>
                ))}
              </ul>
              <button
                data-testid={`plan-cta-${p.name.toLowerCase()}`}
                onClick={onCta}
                className={`mt-8 w-full rounded-[10px] py-3 text-[14px] font-medium transition-transform duration-200 hover:-translate-y-0.5 ${
                  p.featured
                    ? "bg-brand-indigo text-white shadow-[0_8px_24px_rgba(79,70,229,0.3)]"
                    : "border border-[#D3D1C7] bg-white text-brand-ink"
                }`}
              >
                {p.name === "Empresa" ? "Hablemos" : "Pide tu propuesta"}
              </button>
            </motion.div>
          ))}
        </motion.div>

        <Reveal className="mx-auto mt-6 flex max-w-5xl items-start gap-3.5 rounded-[14px] bg-brand-mint/12 p-5 text-[14px] text-[#085041]">
          <SlidersHorizontal size={22} strokeWidth={1.9} className="mt-0.5 flex-shrink-0 text-[#0F6E56]" />
          <span>
            <strong className="font-medium">Personaliza tu plan.</strong> Añade o quita
            funciones de cualquier plan según lo que necesite tu negocio: solo pagas por lo
            que usas.
          </span>
        </Reveal>
      </div>
    </section>
  );
}
